export interface Comic {
  id: string;
  title: string;
  author: string;
  category: string;
  categoryName: string;
  description: string;
  cover: string;
  rating: number;
  chapters: number;
  status: 'ongoing' | 'completed';
  updateDate: string;
  views: number;
  likes: number;
  tags: string[];
}

export const comics: Comic[] = [
  {
    id: 'comic-001',
    title: '我的女神室友',
    author: '金敏秀',
    category: 'romance',
    categoryName: '恋爱',
    description: '平凡的大学生李浩宇意外与校园女神成为室友，两人从最初的尴尬相处到逐渐产生情愫，一段甜蜜又曲折的恋爱故事就此展开。女神背后的秘密也慢慢浮出水面...',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romance%20cover%20art%20young%20couple%20warm%20lighting%20soft%20pastel%20colors%20beautiful%20girl%20and%20handsome%20boy%20anime%20style%20illustration%20clean%20background%20romantic%20atmosphere&width=600&height=800&seq=comic-cover-001&orientation=portrait',
    rating: 4.8,
    chapters: 86,
    status: 'ongoing',
    updateDate: '2026-08-04',
    views: 1256000,
    likes: 89200,
    tags: ['恋爱', '校园', '甜蜜'],
  },
  {
    id: 'comic-002',
    title: '暗黑领主转生记',
    author: '朴志勋',
    category: 'fantasy',
    categoryName: '奇幻',
    description: '最强暗黑领主在最终决战中失败，却意外转生到了现代世界。失去了大部分力量的他，必须在这个陌生的世界中重新崛起，同时面对来自异世界的追兵和现代社会的挑战。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%20art%20dark%20lord%20character%20magical%20energy%20modern%20city%20contrast%20dramatic%20lighting%20anime%20style%20illustration%20epic%20atmosphere%20clean%20composition&width=600&height=800&seq=comic-cover-002&orientation=portrait',
    rating: 4.9,
    chapters: 124,
    status: 'ongoing',
    updateDate: '2026-08-03',
    views: 2350000,
    likes: 156300,
    tags: ['奇幻', '转生', '战斗'],
  },
  {
    id: 'comic-003',
    title: '血色追踪',
    author: '李在勋',
    category: 'thriller',
    categoryName: '悬疑',
    description: '刑警姜宇镇在追查一系列连环杀人案时，发现所有线索都指向十年前的一桩悬案。随着调查深入，他逐渐意识到凶手可能就在身边，而真相远比想象中更加残忍。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20cover%20art%20detective%20character%20dark%20alley%20mysterious%20atmosphere%20red%20accents%20suspenseful%20mood%20anime%20style%20illustration%20noir%20aesthetic%20clean%20composition&width=600&height=800&seq=comic-cover-003&orientation=portrait',
    rating: 4.7,
    chapters: 52,
    status: 'ongoing',
    updateDate: '2026-08-02',
    views: 980000,
    likes: 67500,
    tags: ['悬疑', '犯罪', '推理'],
  },
  {
    id: 'comic-004',
    title: '剑圣的平凡日常',
    author: '郑宇盛',
    category: 'action',
    categoryName: '动作',
    description: '天下第一剑圣厌倦了江湖纷争，隐姓埋名来到城市开了一家小餐馆。但各路高手纷纷找上门来，让他想过平凡生活的愿望一次次落空，一场场精彩对决就此展开。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20cover%20art%20sword%20master%20character%20dynamic%20pose%20urban%20setting%20contrast%20traditional%20and%20modern%20anime%20style%20illustration%20energetic%20composition%20clean%20background&width=600&height=800&seq=comic-cover-004&orientation=portrait',
    rating: 4.6,
    chapters: 68,
    status: 'ongoing',
    updateDate: '2026-08-04',
    views: 1560000,
    likes: 102400,
    tags: ['动作', '武侠', '搞笑'],
  },
  {
    id: 'comic-005',
    title: '秘密花园',
    author: '韩素英',
    category: 'drama',
    categoryName: '剧情',
    description: '富家千金因家族变故流落街头，在人生最低谷时遇到了一位神秘的园艺师。在照料花园的过程中，她逐渐找回了生活的意义，也揭开了一段尘封多年的家族秘密。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20cover%20art%20beautiful%20garden%20elegant%20woman%20flowers%20soft%20natural%20lighting%20emotional%20atmosphere%20anime%20style%20illustration%20warm%20tones%20clean%20composition&width=600&height=800&seq=comic-cover-005&orientation=portrait',
    rating: 4.8,
    chapters: 45,
    status: 'completed',
    updateDate: '2026-07-15',
    views: 870000,
    likes: 78400,
    tags: ['剧情', '治愈', '家族'],
  },
  {
    id: 'comic-006',
    title: '搞笑一家人',
    author: '朴明秀',
    category: 'comedy',
    categoryName: '搞笑',
    description: '四个性格迥异的兄弟姐妹住在同一个屋檐下，每天都上演着令人捧腹的搞笑日常。从抢遥控器到争夺卫生间，每个家庭成员都有说不完的笑料。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20cover%20art%20funny%20family%20characters%20colorful%20bright%20cheerful%20atmosphere%20exaggerated%20expressions%20anime%20style%20illustration%20playful%20composition%20clean%20background&width=600&height=800&seq=comic-cover-006&orientation=portrait',
    rating: 4.5,
    chapters: 110,
    status: 'ongoing',
    updateDate: '2026-08-04',
    views: 1890000,
    likes: 134500,
    tags: ['搞笑', '家庭', '日常'],
  },
  {
    id: 'comic-007',
    title: '深夜的访客',
    author: '崔智友',
    category: 'horror',
    categoryName: '恐怖',
    description: '独居女生金美娜每晚都会听到门外传来奇怪的声音。当她决定安装监控后，看到了令她毛骨悚然的画面——每天晚上凌晨三点，都有一个陌生人在她门外站上整整一小时。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20cover%20art%20dark%20corridor%20eerie%20atmosphere%20shadowy%20figure%20creepy%20mood%20blueish%20dark%20tones%20anime%20style%20illustration%20suspenseful%20composition%20clean%20background&width=600&height=800&seq=comic-cover-007&orientation=portrait',
    rating: 4.6,
    chapters: 38,
    status: 'ongoing',
    updateDate: '2026-08-01',
    views: 720000,
    likes: 52100,
    tags: ['恐怖', '惊悚', '都市传说'],
  },
  {
    id: 'comic-008',
    title: '校园篮球风云',
    author: '张东健',
    category: 'school',
    categoryName: '校园',
    description: '身高只有一米六五的林小凡梦想成为校篮球队主力。在所有人都不看好的情况下，他凭借着超强的意志力和独特的球感一路逆袭，最终带领球队走向全国大赛。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20sports%20school%20cover%20art%20basketball%20player%20dynamic%20action%20court%20setting%20youthful%20energy%20anime%20style%20illustration%20bright%20colors%20clean%20composition%20passionate&width=600&height=800&seq=comic-cover-008&orientation=portrait',
    rating: 4.7,
    chapters: 72,
    status: 'ongoing',
    updateDate: '2026-08-03',
    views: 1430000,
    likes: 96500,
    tags: ['校园', '运动', '热血'],
  },
  {
    id: 'comic-009',
    title: '魔法学院特优生',
    author: '柳承范',
    category: 'fantasy',
    categoryName: '奇幻',
    description: '出身平民家庭的艾琳意外被顶级魔法学院录取，在这个充满贵族子弟的地方，她凭借天赋和努力一步步证明自己。而在学院深处，一个古老的秘密正在苏醒。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20magic%20academy%20cover%20art%20female%20mage%20student%20magical%20school%20castle%20setting%20sparkling%20effects%20anime%20style%20illustration%20elegant%20composition%20clean%20background&width=600&height=800&seq=comic-cover-009&orientation=portrait',
    rating: 4.8,
    chapters: 95,
    status: 'ongoing',
    updateDate: '2026-08-04',
    views: 2100000,
    likes: 142000,
    tags: ['奇幻', '魔法', '学院'],
  },
  {
    id: 'comic-010',
    title: '合约恋人',
    author: '尹恩惠',
    category: 'romance',
    categoryName: '恋爱',
    description: '为了应付家人的催婚，白领姜素拉与公司CEO签订了一份假恋爱合约。本以为只是各取所需的交易，却在朝夕相处中暗生情愫。当合约到期时，他们还能回到从前吗？',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20office%20cover%20art%20elegant%20couple%20business%20setting%20sophisticated%20atmosphere%20warm%20lighting%20anime%20style%20illustration%20chic%20composition%20clean%20background&width=600&height=800&seq=comic-cover-010&orientation=portrait',
    rating: 4.7,
    chapters: 60,
    status: 'completed',
    updateDate: '2026-06-20',
    views: 1670000,
    likes: 118900,
    tags: ['恋爱', '职场', '契约'],
  },
  {
    id: 'comic-011',
    title: '末日生存法则',
    author: '金泰浩',
    category: 'action',
    categoryName: '动作',
    description: '突如其来的丧尸病毒席卷全球，普通上班族韩世俊被迫在末日世界中求生。他联合幸存者建立避难所，在资源匮乏、人心险恶的环境中为生存而战。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20apocalypse%20action%20cover%20art%20survivor%20character%20ruined%20city%20dramatic%20lighting%20intense%20atmosphere%20anime%20style%20illustration%20dark%20tones%20dynamic%20composition%20clean%20background&width=600&height=800&seq=comic-cover-011&orientation=portrait',
    rating: 4.6,
    chapters: 54,
    status: 'ongoing',
    updateDate: '2026-08-04',
    views: 1120000,
    likes: 78500,
    tags: ['动作', '末日', '生存'],
  },
  {
    id: 'comic-012',
    title: '星光下的约定',
    author: '文彩元',
    category: 'drama',
    categoryName: '剧情',
    description: '两位儿时的玩伴因家庭变故被迫分离，约定长大后一定要在星光下重逢。十年后，已成为天文学家的她和成为音乐家的他，在命运的安排下再次相遇。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20cover%20art%20starry%20night%20sky%20couple%20silhouette%20romantic%20atmosphere%20soft%20glow%20anime%20style%20illustration%20dreamy%20composition%20clean%20background%20nostalgic&width=600&height=800&seq=comic-cover-012&orientation=portrait',
    rating: 4.9,
    chapters: 34,
    status: 'completed',
    updateDate: '2026-05-30',
    views: 980000,
    likes: 89600,
    tags: ['剧情', '治愈', '重逢'],
  },
];

export const getComicsByCategory = (categorySlug: string): Comic[] => {
  return comics.filter((c) => c.category === categorySlug);
};

export const getComicById = (id: string): Comic | undefined => {
  return comics.find((c) => c.id === id);
};

export const getPopularComics = (limit: number = 6): Comic[] => {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, limit);
};

export const getLatestComics = (limit: number = 6): Comic[] => {
  return [...comics].sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()).slice(0, limit);
};

export const getTopRatedComics = (limit: number = 6): Comic[] => {
  return [...comics].sort((a, b) => b.rating - a.rating).slice(0, limit);
};

export const getRelatedComics = (comicId: string, limit: number = 4): Comic[] => {
  const comic = comics.find((c) => c.id === comicId);
  if (!comic) return [];
  return comics.filter((c) => c.id !== comicId && c.category === comic.category).slice(0, limit);
};